window.generate_fields = function(report_class) {
    $.each($("."+report_class), function (i, val) {
        $(val).removeClass(report_class);
        create_fields($(val));
    });

    function create_fields(obj) {
        /* Максимум строк */
        var maxLines = 100;
        var padding = 3;

        /* Определяет длинну строки, путем создания спрятанного span-a в obj и рассчитывания его width
         *  obj - объект в котором будет текст,
         *  str - встраиваемый текст
         */
        function stringSize(obj, str) {
            var s = $('<span></span>').css('whiteSpace', "nowrap").css('visibility', "hidden");
            s.text(str);
            obj.append(s);
            var result = s.outerWidth() + padding * 2;
            s.remove();
            return result;
        }

        /* Функция по циклу считает длину строки которую можно запихнуть без переноса в указанное поле */
        function calcLines(obj, str) {
            /* Сразу проверяем а не нужного ли размера у нас строка */
            if (stringSize(obj, str) < obj.outerWidth())
                return str;
            /* Первая временная переменная - длина строки */
            var len = 0;
            /* Вторая переменная нужна чтобы в хранить последнюю удачную длину строки */
            var len2 = 0;

            /* Берем первое слово. Если оно длиннее поля надо сделать перенос слова */
            var local = str.substr(0, str.indexOf(" ", 0));

            /* Если у нас строка без пробелов вообще */
            if (str.indexOf(" ", 0) === -1) local = str;

            if (stringSize(obj, local) > obj.outerWidth()) {
                /* Запускаем цикл обрезающий оооочень длинное слово */
                /* todo-steve Добавить нормальный перенос слов */
                do {
                    len2 = len;
                    /* Отрезаем по два символа */
                    len = local.length - 2;
                    local = str.substr(0, len);
                } while (stringSize(obj, local) > obj.outerWidth());
            }
            else {
                do {
                    len2 = len;
                    len = str.indexOf(" ", local.length + 1);
                    if (len === -1) break;
                    local = str.substr(0, len);
                } while (stringSize(obj, local) < obj.outerWidth());
            }
            return str.substr(0, len2);
        }

        /* Функция для генерации нового имени элемента на ванильном JS */
        function generate_new_name(element) {
            /* Мапим все id таблиц которые только есть, отрезаем у них номера,
            *  фильтруем пустоту и по цыклу определяем максимальное
            * */
            var max = 0;
            $(element).map(function () {
                if (this.id.search("^wu_table") !== -1)
                    return this.id.substr(8);
                if (this.id.search("^table") !== (-1))
                    return this.id.substr(5);
            }).get()
                .filter(function (t) {
                    return t !== undefined
                })
                .forEach(function (item, i, list) {
                    if (+item > max) {
                        max = item;
                    }
                });
            return "wu_" + element + (+max + 1);
        }

        var label = obj.data('label');
        var text = obj.data('text');
        var sub_text = obj.data('sub_text');
        var line_count = obj.data('line_count');

        var tableName = generate_new_name('table');
        var tr_dataName = tableName + "_data";
        var tr_underName = tableName + "_under";

        /* Главная таблица в которой будем собирать поле */
        obj.append($('<table></table>').attr('id', tableName));
        var mainTable = obj.find('table');

        var tr_data = $('<tr></tr>');
        var td_data = $('<td class="underlined_text">&nbsp;</td>');

        var tr_under = $('<tr></tr>');
        var td_under = $('<td class="below_line">&nbsp;</td>');

        /* Первая строка */
        tr_data.attr('id', tr_dataName + '1');
        /* Label */
        tr_data.append("<td class='min'><p>" + label + "</p></td>");
        /* Записываем первую укороченную строчку */
        tr_data.append(td_data);
        mainTable.append(tr_data);

        /* Нужно ли вообще укорачивать? */
        if (stringSize(td_data, text) > td_data.innerWidth()) {
            var tmp_str = calcLines(td_data, text);
            td_data.html("<p>" + tmp_str + "</p>");

            var i = 2;

            while (i < maxLines) {
                tr_data = $('<tr></tr>');
                td_data = $('<td colspan="2" class="underlined_text">&nbsp;</td>');
                tr_data.attr('id', tr_dataName + i);
                tr_data.append(td_data);
                mainTable.append(tr_data);

                text = text.substr(tmp_str.length + 1);
                tmp_str = calcLines(td_data, text);

                td_data.html("<p>" + tmp_str + "</p>");

                /* Если последнее добавление == оставшемуся куску текста то break */
                if (tmp_str === text) break;
                i++;
            }
            /* Пустые строки */
            if (line_count - i > 0)
                for (var k = 0; k < line_count - i; k++)
                    mainTable.append("<tr id='" + tr_dataName + (line_count - i + k) + "'>" +
                        "<td colspan='2' class='underlined_text'>&nbsp;</td></tr>");
        }
        /* Если укорачивать не надо */
        else {
            td_data.html("<p>" + text + "</p>");
            tr_data.append(td_data);
            mainTable.append(tr_data);
            /* Пустые строки */
            if (line_count - 1 > 0)
                for (var l = 0; l < line_count - 1; l++)
                    mainTable.append("<tr id='" + tr_dataName + (l+2) + "'>" +
                        "<td colspan='2' class='underlined_text'>&nbsp;</td></tr>");
        }

        /* Добавляем строки подписей */
        /* Если строки подписи нет ничего не добавляем */
        /* todo-steve Нужно поправить - если подпись будет слишком длинная и не хватит пустых строк и заполненных вылетит ошибка */

        if (sub_text !== "") {
            tr_under.attr('id', tr_underName + "1");
            tr_under.append('<td></td>');
            tr_under.append(td_under);

            $("#" + tr_dataName + "1").after(tr_under);

            /* Проверка на укорачиваемость */
            if (stringSize(td_under, sub_text) > td_under.innerWidth()) {
                /* Записываем первую укороченную строчку */
                tmp_str = calcLines(td_under, sub_text);
                td_under.html("<span>" + tmp_str + "</span>");

                var j = 2;
                while (j < maxLines) {
                    tr_under = $('<tr></tr>');
                    td_under = $('<td colspan="2" class="below_line">&nbsp;</td>');
                    tr_under.attr('id',tr_underName + j);
                    tr_under.append(td_under);
                    $("#" + tr_dataName + j).after(tr_under);

                    sub_text = sub_text.substr(tmp_str.length + 1);
                    tmp_str = calcLines(td_under, sub_text);

                    td_under.html("<span>" + tmp_str + "</span>");
                    /* Если последнее добавление == оставшемуся куску текста то break */
                    if (tmp_str === sub_text) break;
                    j++;
                }
            }
            /* Если укорачивать не надо */
            else
                td_under.html("<span>" + sub_text + "</span>");
        }

    }
}

window.generate_listhead = function(aMenu){
    var tabs = document.getElementById("listhead_tabs");

    var url = window.location.href;
    if (url.substr(-1)==='#') url = url.slice(0,-1);
    if(url.substr(-1)==='/') url = url.slice(0,-1);
    var formName = url.split("/").pop();

    var pills = document.createElement('ul');
    pills.setAttribute('style','border-bottom: 1px solid #ddd');
    pills.setAttribute('class', 'nav nav-pills');

    aMenu.forEach( function (layer1) {
        var pclass = '';
        var tclass = layer1.tclass;
        var tmp_pills = '';
        if (layer1.items !== undefined){
            layer1.items.forEach( function (layer2) {
                /* Без этой магии глючит */
                var subs_li = '';
                var sub_class = '';
                var has_selected_sub = false;
                var has_sub = layer2.hasOwnProperty("items");
                /* Если же все таки у нас активая вкладка */
                /* Определяем нужно ли подключать детей */
                if (has_sub){
                    layer2.items.forEach( function (layer3) {
                        if (layer3.alias === formName) {sub_class = "selected-nav-pill"; has_selected_sub = true;}
                        else sub_class = 'unselected-nav-pill';
                        subs_li += '<li id="tab_pill_'+ layer3.alias +'" class="'+sub_class+'">' +
                            '<a href="' + layer3.link + '">' + layer3.title +'</a>' +
                            '</li>';
                    });
                }

                /* Определяем является ли вкладка активной */
                var isActive = layer2.alias === formName;

                /* Если вкладка не активна и не имеет детей */
                if (!isActive && !has_selected_sub) {
                    if (tclass === (layer1.tclass + " active"))
                        tclass = layer1.tclass + " active";
                    else
                        tclass = layer1.tclass;
                    tmp_pills += '<li id="tab_'+ layer2.alias +'" class="unselected-pills-container">' +
                        '<a href="' + layer2.link + '">' + layer2.title +'</a>' +
                        '</li>';
                }
                /* Если активна или имеет детей */
                else {
                    tclass += " active";
                    var li = '';
                    if (isActive)
                    {
                        if (has_sub) pclass = "selected-nav-pill";
                        else pclass = "unselected-nav-pill";
                        li = '<li class="'+ pclass +'">' + layer2.title +'</li>';
                    }
                    else
                    {
                        li = '<li class="unselected-nav-pill">' +
                            '<a href="'+ layer2.link + '">' + layer2.title +'</a>' +
                            '</li>';
                    }

                    tmp_pills += '' +
                        '<li class="selected-pills-container">' +
                        '<ul class="selected-nav-ul">' +
                        li +
                        subs_li +
                        '</ul>' +
                        '</li>';
                }
            });
            /* Если вкладка активна то добавляем подвкладки */
            if ((tclass!==layer1.tclass)&&(layer1.items.length !== 0)) {
                pills.innerHTML += tmp_pills;
                document.getElementById("listhead_pills").appendChild(pills);
            }
        }
        else {
            if(layer1.alias === formName) tclass += " active";
        }

        tabs.innerHTML += '<li id="'+layer1.alias+'" class="'+tclass+'">'+
            '<a href="'+layer1.link+'">'+layer1.title+'</a>' +
            '</li>';
    })
}
